import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Form, Row, Col, Button, Container, Table } from "react-bootstrap";
import { getTermsheets } from "redux/actions";
import { reduxFormSearch } from "components/form/ReduxForm";
import Spacer from "components/layout/Spacer";
import { Field, reduxForm } from "redux-form";

function TermsheetCreateFromTemplate(props) {
  const [searchInput, setSearchInput] = useState("");
  const [termsheet, setTermsheet] = useState();

  useEffect(() => {
    let options;
    if (props.mySavedOnly) {
      options = { companyId: props.myCompany._id };
    }
    getTermsheets("", true, 1, 100, options);
  }, []);

  const termsheetList = useMemo(() => {
    return props.termsheets.filter((e) =>
      e.termsheetName.toLocaleLowerCase().includes(searchInput)
    );
  }, [props.termsheets, searchInput]);

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <Container className="create-from-deal">
      <Form className="no-border">
        <Row>
          <Col xs={12}>
            <h4 className="text-heading">
              {props.mySavedOnly ? "My Saved Templates" : "Termsheet Templates"}
            </h4>
            <Spacer size={20} />
          </Col>
          <Col xs={{ span: 10, offset: 1 }}>
            <Field
              className="form-control"
              component={reduxFormSearch}
              name="search"
              type="text"
              placeholder="Search"
              inputValue={searchInput}
              input={{
                onChange: handleSearchChange,
              }}
            />
            <Spacer size={10} />

            <Table responsive="sm">
              <thead>
                <tr>
                  <th>Template Name</th>
                  <th style={{ width: 160 }}>Owner</th>
                  <th className="text-center" style={{ width: 160 }}>
                    Date Last Edited
                  </th>
                </tr>
              </thead>
              <tbody>
                {termsheetList.map((ts) => (
                  <tr
                    key={ts._id}
                    className={
                      ts._id === termsheet?._id ? "row-item-primary" : ""
                    }
                    onClick={() => setTermsheet(ts)}
                  >
                    <td>{ts.termsheetName}</td>
                    <td>
                      {ts.owner?.firstName} {ts.owner?.lastName}
                    </td>
                    <td className="text-center">
                      {new Date(ts.updatedAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Spacer size={60} />

        <Row>
          <Col className="d-flex justify-content-end">
            <Button variant="primary" className="mr-2" onClick={props.onCancel}>
              Go Back
            </Button>
            <Button
              disabled={!termsheet?._id}
              variant="tertiary"
              onClick={() => props.onSubmit(termsheet?._id, termsheet)}
            >
              Select
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}
function mapStateToProps(state) {
  return {
    action: state.action,
    myCompany: state.company.myCompany,
    termsheet: state.termsheet.termsheet,
    termsheets: state.termsheet.termsheets,
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "TermsheetCreateFromTemplate",
    enableReinitialize: true,
  })(TermsheetCreateFromTemplate)
);
